{
  "it": {
    "marketplace_partner": {
      "contact_me": {
        "success": "La contatteremo a breve.",
        "failure": "Si è verificato un errore imprevisto.",
        "button": "Contattami"
      }
    }
  }
}
